//TODO: Done; Export the Footer
import React from "react";

const Footer = () => {
  return (
    <footer className="bg-info text-center pt-3 pb-2 mt-5 sticky-bottom">
      A simple Contact App
    </footer>
  );
};
export default Footer;
